import { render, staticRenderFns } from "./DkMediaCounterDST.vue?vue&type=template&id=63bdd98a&"
import script from "./DkMediaCounterDST.vue?vue&type=script&lang=js&"
export * from "./DkMediaCounterDST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports